import React from "react";
import "../Styles/AuthError.css";

function AuthError({ message, onClose }) {
  return (
    <div className="auth-error-overlay" dir="rtl">
      <div className="auth-error-card">
        <h2>שגיאה בהתחברות</h2>
        <p>{message}</p>
        <button onClick={onClose}>סגור</button>
      </div>
    </div>
  );
}

export default AuthError;